import { useNavigate } from 'react-router-dom';
import { MapPin, TrendingUp, ArrowRight } from 'lucide-react';
import SectionReveal from './SectionReveal';

const statusStyles = {
  'Investment Q3 2026': 'bg-[#D4A017]/20 text-[#D4A017] border-[#D4A017]/50',
  'Investiție T3 2026': 'bg-[#D4A017]/20 text-[#D4A017] border-[#D4A017]/50',
  'RTB': 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30',
  'Operational': 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  'Closed': 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  'Under Construction': 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  'Under Development': 'bg-orange-500/15 text-orange-400 border-orange-500/30',
  'Permitting Phase': 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  'Operațional': 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  'Finalizat': 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  'În Construcție': 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  'În Dezvoltare': 'bg-orange-500/15 text-orange-400 border-orange-500/30',
  'Faza de Autorizare': 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  'Under Evaluation': 'bg-sky-400/15 text-sky-300 border-sky-400/40',
  'În Evaluare':      'bg-sky-400/15 text-sky-300 border-sky-400/40',
  'Disponibil Acum': 'bg-[#D4A017]/15 text-[#D4A017] border-[#D4A017]/50',
};

function ProjectCard({ project, index, onNavigate }) {
  const isSpecial = !!project.link;
  return (
    <SectionReveal delay={index * 60}>
      <div
        className={`border p-6 transition-all duration-300 h-full flex flex-col ${
          isSpecial
            ? 'border-[#D4A017]/40 bg-[#D4A017]/5 hover:border-[#D4A017]/80 hover:bg-[#D4A017]/8 cursor-pointer'
            : 'border-white/8 bg-[#0d0d0d] hover:border-white/20'
        }`}
        onClick={isSpecial ? () => onNavigate(project.link) : undefined}
        data-testid={`project-card-${index}`}
      >
        <div className="flex items-start justify-between mb-4">
          <span className={`text-xs font-medium px-2 py-1 border tracking-wide ${statusStyles[project.status] || 'bg-white/5 text-white/40 border-white/10'}`}>
            {project.status}
          </span>
          {isSpecial && <ArrowRight size={15} className="text-[#D4A017] mt-0.5 flex-shrink-0" />}
        </div>
        <h3
          className={`text-base font-semibold mb-4 flex-1 ${isSpecial ? 'text-[#D4A017]' : 'text-white'}`}
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          {project.title}
        </h3>
        <div className="space-y-2 mt-auto">
          <div className="flex items-center gap-2">
            <MapPin size={12} className="text-white/30 flex-shrink-0" />
            <span className="text-xs text-white/45">{project.location}</span>
          </div>
          <div className="flex items-center gap-2">
            <TrendingUp size={12} className={isSpecial ? 'text-[#D4A017]/50 flex-shrink-0' : 'text-white/30 flex-shrink-0'} />
            <span className={`text-xs ${isSpecial ? 'text-[#D4A017]/70' : 'text-white/45'}`}>{project.capacity}</span>
          </div>
          <div className="text-xs text-white/30 pt-1 border-t border-white/5">{project.type}</div>
          {isSpecial && <div className="text-xs text-[#D4A017]/80 font-medium pt-1">Discover the Technology →</div>}
        </div>
      </div>
    </SectionReveal>
  );
}

export default function ProjectsSection({ text }) {
  const navigate = useNavigate();
  return (
    <section id="projects" className="py-24 sm:py-32 bg-[#050505]">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <SectionReveal>
          <div className="mb-16">
            <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium">{text.label}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {text.title}
            </h2>
          </div>
        </SectionReveal>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {text.items.map((project, i) => (
            <ProjectCard key={project.title} project={project} index={i} onNavigate={navigate} />
          ))}
        </div>
      </div>
    </section>
  );
}
